module.exports = __webpack_public_path__ + "static/media/Avenir-Black.446f4fa9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Avenir-Black.ttf
// module id = 73
// module chunks = 0